import { Component, NgModule, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, ChangeDetectorRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, delay, Observable, retry, Subject} from 'rxjs';

import { Subscription } from 'rxjs';



import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';
import { Payment } from './../../../shared/models/payment.model';

import { NgForm } from '@angular/forms';
import { SubjectWorkOrder } from './../../../shared/models/subjectWorkOrder.model';
import { SubjectWorkOrderItem } from './../../../shared/models/subjectWorkOrderItem.model';

import { SubjectCostComponent } from './../../../admin/jobs/subjects/subject-billing/subject-cost/subject-cost.component';
import { WorkOrdersGridComponent } from '../../grid/work-orders-grid/work-orders-grid.component';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-update-work-order-widget',
  templateUrl: './update-work-order-widget.component.html',
  styleUrls: ['./update-work-order-widget.component.css'],
  providers: [SubjectCostComponent]
})
export class UpdateWorkOrderWidgetComponent implements OnInit {


     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes.
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full
  
     job: Object;
     @Input() job_id: Observable<any[]>; 
     @Input() subject_id: Observable<any[]>; 
     @Input() subject_number?: Observable<any[]>;
     @Input() job_number: Observable<any[]>;
     @Input() invoice_id: Observable<any[]>;

     @Input() work_order_id: Observable<any[]>;


     @Input() agent_id;
     @Input() agent_name_full: string;
   // access the template form
   @ViewChild('invoiceForm') invoiceForm: NgForm;

    @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
 //   @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();

     invoice_model: SubjectInvoice = new SubjectInvoice();
     invoice_item_model: any = SubjectInvoiceItem;

// work_order_model: SubjectWorkOrder;
work_order_model: any = [];
work_order_item_model: SubjectWorkOrderItem;

  brand_invoice_id: any;
  brand: any;
  invoice_brand: any;
  subject_billing_items: any;
  owner_brand: any;

  // holding array items;
  invoiceItemsList: any = [];
  invoiceItem: any = [];

  workOrderItemsList: any = [];
  workOrderItem: any = [];

  isShowEdit = false ; // hidden by default]
  isShow; // hidden by default
  invoice_total: any;
  invoice_tax: number;
  invoice_subtotal: number;
  invoice_job_type_id: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;

  public today = Date.now();
  modalRef: BsModalRef;
  invoice_status_all: any;
  invoice_payment_status_all: any;
  invoice_communication_status_all: any;
  valueDatePickerDate: Date;
  expanded = false;
  new_invoice_id: any;
  returned_invoice_id: any;
  invoice_number: any;
  returned_invoice_item_id: any;
  new_invoice_item_id: any;
  subject: any;
  invoice_status: any;
  invoice_status_name: any;
  invoice_payment_status: any;
  invoice_payment_status_name: any;
  invoice_communication_status: any;
  invoice_communication_status_name: any;
  invoice_status_id: any;
  invoice_payment_status_id: any;
  invoice_communication_status_id: any;
  invoice_status_var: any;
  invoice_payment_status_var: any;
  invoice_communication_status_var: any;
  work_order_status_all: any;
  work_order_payment_status_all: any;
  work_order_communication_status_all: any;
  work_order_number: any;
  work_order_status: any;
  work_order_status_name: any;
  work_order_status_var: any;
  work_order_payment_status: any;
  work_order_payment_status_name: any;
  work_order_payment_status_var: any;
  work_order_communication_status: any;
  work_order_communication_status_name: any;
  work_order_communication_status_var: any;
  work_order_total: number;
  work_order_tax: number;
  work_order_subtotal: number;
  subject_work_order_items: any;
  new_work_order_item_id: any;
  returned_work_order_item_id: any;
  agent_brand: any;
  agent_full_name: any;
  assignedBrandList: any;
  selected_agent_id: any;
  work_order_brand: any;
  subject_cost_items: any;
  
  expanded2 = false;
  SupplierInvoiceNumber: any;
  work_order_myob_id: any;
  
    constructor(
      private http: HttpClient, private _demoService: DemoService,
      private route: ActivatedRoute, public toastr: HotToastService,
       vcr: ViewContainerRef, private router: Router,
       public HttpClient:HttpClient,
       private fileUploader: FileUploaderService,
       private _mysqlService: MysqlService,
       private modalService: BsModalService,
       public datepipe: DatePipe,
       public gfunc: GlobalFunctionsService,
       private cdr:ChangeDetectorRef, // allows for change detection once pushed data to an array
     public _WorkOrdersGridComponent: WorkOrdersGridComponent


    ) {
       // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


// Date picker date format
   this.valueDatePickerDate = new Date(this.today);
     }
  
     // check for changes. to load data.
     ngOnChanges(changes) {


// console.log('InvoiceID: ' + this.invoice_id);
  // this.invoice_model = new SubjectInvoice();
 // this.invoice_item_model = new SubjectInvoiceItem();
 // this.getInvoice(this.invoice_id);
  
 // this.getSubjectBillingItems(this.subject_id);


  if (changes.work_order_id) {
    this.work_order_id = changes.work_order_id.currentValue;

    this.getJobSubject(this.subject_id);
    this.getSubjectAgentBrandsAssigned(this.subject_id);
    this.getJob(this.job_id);

    // this.getInvoiceStatusAll();
    // this.getInvoicePaymentStatusAll();
    // this.getInvoiceCommunicationStatusAll();

    this.getWorkOrderStatusAll();
    this.getWorkOrderPaymentStatusAll();
    this.getWorkOrderCommunicationStatusAll();

    this.getWorkOrder(this.work_order_id);
    this.getWorkOrderItems(this.work_order_id);
    // this.getInvoice(this.invoice_id);
    // this.getInvoiceItmes(this.invoice_id);
  this.doCalculations_ONLOAD(); // may need to adjust to update pricing details?? // untested but was not loading when changing work order status....?


  }



if (changes.item_id) {
        // deal with asynchronous Observable result
      //  this.job_id = changes.item_id.currentValue;
        // this.getJob(this.job_id);
      }
    }
  
  
    ngOnInit() {
      // this.getJobSubject(this.subject_id);
      // this.getSubjectAgentBrandsAssigned(this.subject_id);
      // this.getJob(this.job_id);
  
      // // this.getInvoiceStatusAll();
      // // this.getInvoicePaymentStatusAll();
      // // this.getInvoiceCommunicationStatusAll();
  
      // this.getWorkOrderStatusAll();
      // this.getWorkOrderPaymentStatusAll();
      // this.getWorkOrderCommunicationStatusAll();
  
      // this.getWorkOrder(this.work_order_id);
      // this.getWorkOrderItems(this.work_order_id);

    }
  

   // Functions
 
   getInvoice(invoice_id){
    this._demoService.getSubjectInvoice(invoice_id).subscribe(
      (data) => {
        this.invoiceItem = data;
        let res = data[0];
        this.invoice_number = res.invoice_number;

        // Set status based in ID - For template interactions // RULES
        // this.invoice_status_text = 'PAID';
        this.getInvoiceStatus(res.invoice_status_id);
        this.getInvoicePaymentStatus(res.invoice_payment_status_id);
        this.getInvoiceCommunicationStatus(res.invoice_communication_status_id);

        this.invoice_model = this.invoiceItem;
        this.doCalculations();
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    ) };


   
    getWorkOrder(work_order_id){
      this._demoService.getSubjectWorkOrder(work_order_id).subscribe(
        (data) => {
          this.workOrderItem = data;
          let res = data[0];
          this.work_order_number = res.work_order_number;
          this.work_order_total = res.work_order_total;
          this.SupplierInvoiceNumber = res.SupplierInvoiceNumber;

          this.work_order_myob_id = res.myob_id;
          this.agent_id = res.agent_id;

  
          // Set status based in ID - For template interactions // RULES
          // this.work_order_status_text = 'PAID';
          // this.getInvoiceStatus(res.work_order_status_id);
          // this.getInvoicePaymentStatus(res.work_order_payment_status_id);
          // this.getInvoiceCommunicationStatus(res.work_order_communication_status_id);
          // console.log('Agent Brand Model: ' + JSON.stringify(res));
          this.getWorkOrderStatus(res.work_order_status_id);
          this.getWorkOrderPaymentStatus(res.work_order_payment_status_id);
          this.getWorkOrderCommunicationStatus(res.work_order_communication_status_id);
          // load the agent details
          // console.log('Agent Brand Model: ' + JSON.stringify(res));
          // console.log('Work Order Agent ID: ' + JSON.stringify(this.workOrderItem.agent_id));
          // console.log('Work Order Agent ID: ' + JSON.stringify(res.agent_id));

          this.getWorkOrderAgentBrand(res.agent_id);
  

          this.work_order_model = this.workOrderItem;
 this.doCalculations_ONLOAD();
        },
        (err) => console.error(err),
       // () => console.log('Brand Loaded.')
      ) };
    

     
   getInvoiceItmes(invoice_id){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];

        this.invoice_item_model = this.invoiceItemsList;
        this.doCalculations_ONLOAD();
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    ) };
 


    getWorkOrderItems(work_order_id){
      this._demoService.getSubjectWorkOrderItems(work_order_id).subscribe(
        (data) => {
          this.workOrderItemsList = data;
          let res = data[0];
  
          this.work_order_item_model = this.workOrderItemsList;
          // this.getWorkOrderAgentBrand(res.agent_id);
         this.doCalculations();
        },
        (err) => console.error(err),
       // () => console.log('Brand Loaded.')
      ) };
   


    
    getJobSubject(subject_id) {
      this._demoService.getJobSubject(subject_id).subscribe(
        data => { this.subject = data;
          let res = data[0];
          this.subject_number = res.subject_number;
         // this.job_number = res.job_id + '.1'; // made up
         // console.log("Done loadng USER");
        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }
 
 
    getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        let res = data[0];
        // Run the job data queries.
      this.brand_invoice_id =  res.brand_invoice_id;
      this.invoice_job_type_id = res.job_type_id;
      this.getWorkOrderBrand(res.brand_invoice_id);
   
      this.getOwnerBrand(94);

// setup the invoice holding data (this did NOT load the form data without running a ngfor statement)
  // Setup the SubjectInvoice
  // this.invoiceItem.push({
  //   invoice_number: this.subject_number,
  //   job_id: this.job_id,
  //   to_brand_id: this.brand_invoice_id,
  //   subject_id: this.subject_id,
  //   job_type_id: this.invoice_job_type_id,
  //   file_id: null,
  //   created_by: this.sessionUserId,
  // //  date_created: this.today,
  //   invoice_total: this.invoice_total,
  //   invoice_gst: this.invoice_tax,
  //   invoice_subtotal: this.invoice_subtotal,
  //   invoice_status_id: 1,
  //   invoice_payment_status_id: 1,
  //   invoice_communication_status_id: 1,
  //   from_brand_id: 94,
  // //  due_date: this.today,
  //   job_number: this.job_number,
  //         });



/*
          this.invoiceItem = [{
            invoice_number: this.subject_number,
            job_id: this.job_id,
            to_brand_id: this.brand_invoice_id,
            subject_id: this.subject_id,
            job_type_id: this.invoice_job_type_id,
            file_id: null,
            created_by: this.sessionUserId,
            date_created: this.valueDatePickerDate,
            invoice_total: this.invoice_total,
            invoice_gst: this.invoice_tax,
            invoice_subtotal: this.invoice_subtotal,
            invoice_status_id: '1',
            invoice_payment_status_id: '1',
            invoice_communication_status_id: '1',
            from_brand_id: 94,
            due_date: this.valueDatePickerDate,
            job_number: this.job_number,
          }];

          this.invoice_model = this.invoiceItem;

*/

          // :: In order to reflect the data changes on the template, you need to use detect changes, DID NOTHING!
          // ::: constructor(private cdr:ChangeDetectorRef) 
          // and apply the following once you push the data  
          // ::: this.cdr.detectChanges();
         this.cdr.detectChanges();

       this.doCalculations_ONLOAD();
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   private getInvoiceBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.invoice_brand = data;
        let res = data[0];
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }


  private getWorkOrderBrand(agent_id) {
    this._demoService.getBrandById(agent_id).subscribe(
      (data) => {
        this.work_order_brand = data;
        let res = data[0];
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }


  // public getInvoiceAgentBrand(brand_id) {
  //   this._demoService.getBrandById(brand_id).subscribe(
  //     (data) => {
  //       this.agent_brand = data;
  //       let res = data[0];
  //       this.agent_full_name = res.name;
  //       this.work_order_model.agent_full_name = res.name;
  //       this.invoiceForm.controls['agent_full_name'].setValue(this.agent_full_name); // sets the form value.
  //       // set the to_brand_id // so we dont have to change for evertyning
  //       this.work_order_model.to_brand_id = brand_id;
  //       this.invoiceForm.controls['to_brand_id'].setValue(brand_id); // sets the form value.

  //       this.selected_agent_id = brand_id;

  //     },
  //     (err) => console.error(err),
  //     () => console.log('Brand Loaded.')
  //   );
  // }


  


  public getWorkOrderAgentBrand(agent_id) {
    this._demoService.getBrandById(agent_id).subscribe(
      (data) => {
        this.agent_brand = data;
        let res = data[0];
        // this.agent_full_name = this.agent_brand[0].agent_full_name;
        // this.work_order_model.agent_full_name = this.agent_brand[0].agent_full_name;

        // this.invoiceForm.controls['agent_full_name'].setValue(res.name); // sets the form value.
        this.work_order_model.agent_full_name = res.name;
        // set the to_brand_id // so we dont have to change for evertyning
        this.work_order_model.to_brand_id = agent_id;
        // this.invoiceForm.controls['SupplierInvoiceNumber'].setValue(this.SupplierInvoiceNumber);

        this.selected_agent_id = agent_id;

      },
      (err) => console.error(err),
      () => console.log('Agent Loaded.')
    );
  }

  
  private getOwnerBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.owner_brand = data;
        let res = data[0];
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }



  getInvoiceStatus(invoice_status_id){
    this._demoService.getInvoiceStatus(invoice_status_id).subscribe(
      (data) => {
        this.invoice_status = data;
        let res = data[0];
        this.invoice_status_name = res.invoice_status_name;
        this.invoice_status_var = invoice_status_id;
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


 
  getWorkOrderStatus(work_order_status_id){
    this._demoService.getWorkOrderStatus(work_order_status_id).subscribe(
      (data) => {
        this.work_order_status = data;
        let res = data[0];
        this.work_order_status_name = res.work_order_status_name;
        this.work_order_status_var = work_order_status_id;
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }
 

  
  getInvoicePaymentStatus(invoice_payment_status_id){
    this._demoService.getInvoicePaymentStatus(invoice_payment_status_id).subscribe(
      (data) => {
        this.invoice_payment_status = data;
        let res = data[0];
        this.invoice_payment_status_name = res.invoice_payment_status_name;
        this.invoice_payment_status_var = invoice_payment_status_id;
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  
  getWorkOrderPaymentStatus(work_order_payment_status_id){
    this._demoService.getWorkOrderPaymentStatus(work_order_payment_status_id).subscribe(
      (data) => {
        this.work_order_payment_status = data;
        let res = data[0];
        this.work_order_payment_status_name = res.work_order_payment_status_name;
        this.work_order_payment_status_var = work_order_payment_status_id;
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }



  getInvoiceCommunicationStatus(invoice_communication_status_id){
    this._demoService.getInvoiceCommunicationStatus(invoice_communication_status_id).subscribe(
      (data) => {
        this.invoice_communication_status = data;
        let res = data[0];
        this.invoice_communication_status_name = res.invoice_communication_status_name;
        this.invoice_communication_status_var = invoice_communication_status_id;
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getWorkOrderCommunicationStatus(work_order_communication_status_id){
    this._demoService.getWorkOrderCommunicationStatus(work_order_communication_status_id).subscribe(
      (data) => {
        this.work_order_communication_status = data;
        let res = data[0];
        this.work_order_communication_status_name = res.work_order_communication_status_name;
        this.work_order_communication_status_var = work_order_communication_status_id;
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }




  getWorkOrderStatusAll(){
    this._demoService.getWorkOrderStatusAll().subscribe(
      (data) => {
        this.work_order_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getInvoicePaymentStatusAll(){
    this._demoService.getInvoicePaymentStatusAll().subscribe(
      (data) => {
        this.invoice_payment_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  getWorkOrderPaymentStatusAll(){
    this._demoService.getWorkOrderPaymentStatusAll().subscribe(
      (data) => {
        this.work_order_payment_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  getInvoiceCommunicationStatusAll(){
    this._demoService.getInvoiceCommunicationStatusAll().subscribe(
      (data) => {
        this.invoice_communication_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getWorkOrderCommunicationStatusAll(){
    this._demoService.getWorkOrderCommunicationStatusAll().subscribe(
      (data) => {
        this.work_order_communication_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getSubjectBillingItemsSaveToInvoice(subject_id) {
    // empty array of invoiceItemsList first
   this.invoiceItemsList = [];
    this._demoService.getSubjectBillingItems(subject_id).subscribe(
      data => { this.subject_billing_items = data;

        // :: lenght object ::  filter the array for all not invoiced - as API returns all. an easier coding way.
      let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
  // do some totals and tax calculations.

 let tax_percent;
 let tax_value = 0;
  if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4 ) {
    tax_percent = 10;
    tax_value = (res.billing_task_fee / (100 / tax_percent));
        // fix for two decimaal precicion for myob
        let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
        tax_value = rounded_tax_value;
        // tax_value = (res.billing_task_fee / 11); // exclusive
      //  new_total = (+res.billing_task_fee + +tax_value); // + GST
      //  let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
      //  new_total = rounded_new_total;
  }
  if(res.myob_tax_code_id == 2 || res.myob_tax_code_id == 5 ) {
    tax_percent = 0;
    tax_value = 0;
  }

  // :: added the invvoice items needed to the array push.

        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
       this.invoiceItemsList.push({
invoice_number: res.job_number,
invoice_id: this.invoice_id,
// invoice_item_id: res.invoice_item_id, // we dont have this yet? as you are inserting...
billing_task_id: res.billing_task_id,
subject_billing_item_id: res.subject_billing_item_id,
billing_task_name: res.billing_task_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
billing_task_fee: res.billing_task_fee,
billing_task_description: res.billing_task_description,
subject_id: res.subject_id,
subject_number: res.subject_number,
job_id: res.job_id,
job_number: res.job_number,
qty: 1,
unit_price: res.billing_task_fee,
tax: tax_value,
total: res.billing_task_fee,
      });



    // TOD:::
// :: Add for Update to insert subjectBillingItems into invoiceItems.
   // :: while in s in a loop
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.addSubjectInvoiceItem(invoiceData, this.invoice_id);
   // :: Update the status of the subjectBillingItems because we added them to the invoice items database
  let invoice_status = "INVOICED";


  setTimeout( () => { 
    this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.invoice_id, this.invoice_number, invoiceData);
   }, 400 );



  this.invoiceItemsList = this.invoiceItemsList; // know Idear if I even need this in the loop???? seems I do?

// this.invoiceItemsList = [{
//   invoice_number: res.job_number,
//   billing_task_id: res.billing_task_id,
//   subject_billing_item_id: res.subject_billing_item_id,
//   billing_task_name: res.billing_task_name,
//   myob_tax_code_id: res.myob_tax_code_id,
//   myob_account_code_id: res.myob_account_code_id,
//   billing_task_fee: res.billing_task_fee,
//   billing_task_description: res.billing_task_description,
//   subject_id: res.subject_id,
//   subject_number: res.subject_number,
//   job_id: res.job_id,
//   job_number: res.job_number,
//   qty: 1,
//   unit_price: res.billing_task_fee,
//   tax: tax_value,
//   total: res.billing_task_fee,
//         }];

    } // end for loop count


    // refresh the invoice data.
    // this.getInvoice(this.invoice_id);

    this.toastr.success('Invoice & Billing Items Added: Please open Invoice again to view changes.');
    // this.closeParentModel.emit();
    // :: Now refresh the invoice page below to reflect changes in subjectBillingItems.

    setTimeout( () => { 
      this.refreshSujectInvoicePage(this.subject_id);
     }, 2000 );

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);

// set a delay to load invoice items.. THIS WORKED!!!!!! 
setTimeout( () => { 
  this.getInvoiceItmes(this.invoice_id);
 }, 800 );

 this.doCalculations();
return true;

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );

// this.invoiceItemsList = [];    
// this.getInvoice(this.invoice_id);
// this.getInvoiceItmes(this.invoice_id);
 this.doCalculations();
  }



  getSubjectCostItemsSaveToWorkOrder(subject_id) {
    // empty array of invoiceItemsList first
   this.workOrderItemsList = [];
    this._demoService.getSubjectCostItems(subject_id).subscribe(
      data => { this.subject_work_order_items = data;

        // console.log('' + JSON.stringify(data) );

        console.log('workOrderItem' + JSON.stringify(this.workOrderItem) );
        console.log('AgentIDFrom workOrderItem' + this.workOrderItem.agent_id );

        // :: lenght object ::  filter the array for all not applied - as API returns all. an easier coding way.
      let newArr = Object(data).filter((sbi)=>(sbi.work_order_status === 'NOT-APPLIED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
  // do some totals and tax calculations.

 let tax_percent;
 let tax_value = 0;
  if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4 ) {
    tax_percent = 10;
    tax_value = (res.cost_task_fee / (100 / tax_percent));
        // fix for two decimaal precicion for myob
        let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
        tax_value = rounded_tax_value;
        // tax_value = (res.billing_task_fee / 11); // exclusive
      //  new_total = (+res.billing_task_fee + +tax_value); // + GST
      //  let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
      //  new_total = rounded_new_total;
  }
  if(res.myob_tax_code_id == 2 || res.myob_tax_code_id == 5 ) {
    tax_percent = 0;
    tax_value = 0;
  }

  // :: added the invvoice items needed to the array push.

        // push to holding list of work_order items, all current subject_billing_items. (no filtering as yet.)
       this.workOrderItemsList.push({
work_order_number: res.job_number,
work_order_id: this.work_order_id,
// work_order_item_id: res.work_order_item_id, // we dont have this yet? as you are inserting...
cost_task_id: res.cost_task_id,
subject_cost_item_id: res.subject_cost_item_id,
cost_task_name: res.cost_task_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
cost_task_fee: res.cost_task_fee,
cost_task_description: res.cost_task_description,
subject_id: res.subject_id,
subject_number: res.subject_number,
job_id: res.job_id,
job_number: res.job_number,
  // new feb 2023
  qty: res.qty,
  unit_price: res.cost_task_fee,
  tax: res.tax,
  total: res.total,
  // total: new_total,
agent_id: this.selected_agent_id,
agent_full_name: this.agent_full_name
      });

   // :: while in s in a loop
   let workOrderData = this.workOrderItemsList[i];
   // :: add the items
   this.addSubjectWorkOrderItem(workOrderData, this.work_order_id);
   // :: Update the status of the subjectBillingItems because we added them to the invoice items database
  let work_order_status = "APPLIED";


  setTimeout( () => { 
    this.updateSubjectCostItemWorkOrderStatus(work_order_status, workOrderData.subject_cost_item_id, this.work_order_id, this.work_order_number, this.selected_agent_id, workOrderData);
   }, 100 );
  


  this.workOrderItemsList = this.workOrderItemsList; // know Idear if I even need this in the loop???? seems I do?
} // end for loop count

    this.toastr.success('Work Order & Items Added.');
    // this.closeParentModel.emit();
    // :: Now refresh the invoice page below to reflect changes in subjectBillingItems.

    setTimeout( () => { 
      this.refreshSujectWorkOrderPage(this.subject_id);
     }, 200 );

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total = this.invoiceItemsList.reduce((acc, val) => acc += (val.cost_task_fee * val.qty ), 0);

// set a delay to load invoice items.. THIS WORKED!!!!!! 
setTimeout( () => { 
  this.getWorkOrderItems(this.work_order_id);
 }, 800 );

 this.doCalculations();
return true;

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );

 this.doCalculations();
  }


  getSubjectBillingItems(subject_id) {
    // empty array of invoiceItemsList first
    this.invoiceItemsList = [];
    this._demoService.getSubjectBillingItems(subject_id).subscribe(
      data => { this.subject_billing_items = data;

      let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
  // do some totals and tax calculations.

 let tax_percent;
 let tax_value = 0;
  if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4 ) {
    tax_percent = 10;
    tax_value = (res.billing_task_fee / (100 / tax_percent));
        // fix for two decimaal precicion for myob
        let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
        tax_value = rounded_tax_value;
        // tax_value = (res.billing_task_fee / 11); // exclusive
      //  new_total = (+res.billing_task_fee + +tax_value); // + GST
      //  let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
      //  new_total = rounded_new_total;
  }
  if(res.myob_tax_code_id == 2 || res.myob_tax_code_id == 5 ) {
    tax_percent = 0;
    tax_value = 0;
  }
 
  // @ :: Added invoice id to the list on update items.
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
       this.invoiceItemsList.push({
invoice_number: res.job_number,
invoice_id: this.invoice_id,
billing_task_id: res.billing_task_id,
subject_billing_item_id: res.subject_billing_item_id,
billing_task_name: res.billing_task_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
billing_task_fee: res.billing_task_fee,
billing_task_description: res.billing_task_description,
subject_id: res.subject_id,
subject_number: res.subject_number,
job_id: res.job_id,
job_number: res.job_number,
qty: 1,
unit_price: res.billing_task_fee,
tax: tax_value,
// total: res.billing_task_fee,
total: res.total,

      });


      this.invoiceItemsList = this.invoiceItemsList;

// this.invoiceItemsList = [{
//   invoice_number: res.job_number,
//   billing_task_id: res.billing_task_id,
//   subject_billing_item_id: res.subject_billing_item_id,
//   billing_task_name: res.billing_task_name,
//   myob_tax_code_id: res.myob_tax_code_id,
//   myob_account_code_id: res.myob_account_code_id,
//   billing_task_fee: res.billing_task_fee,
//   billing_task_description: res.billing_task_description,
//   subject_id: res.subject_id,
//   subject_number: res.subject_number,
//   job_id: res.job_id,
//   job_number: res.job_number,
//   qty: 1,
//   unit_price: res.billing_task_description,
//   tax: tax_value,
//   total: res.billing_task_fee,
//         }];

    } // end for loop count

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);
this.doCalculations();

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
 


  createSubjectInvoice(invoice_model) {

// invoice_model = [invoice_model]; // see if I can trick to make an object from form values missing brackets [{}]
// // :: need to add the [0] for #formname.value inserts.
// console.log(invoice_model);
//     this._demoService.createSubjectInvoice(invoice_model[0]).subscribe(
//        data => {  this.new_invoice_id = data;
//         let res = data[0];
//         // Run the insert of insert objects through a loop.
//         // let invoice_id = res.last_insert_id;

//         // console.log('InvoiceID: ' + invoice_id);

//         this.toastr.success('Invoice Entered');
//         this.closeParentModel.emit();
//       },
//        err => console.error(err),
//        // () => console.log('done loading Trace Types')
//      );



     this._demoService.createSubjectInvoice(invoice_model).subscribe(
      data => {  this.new_invoice_id = data; // this is the retuned json upon creation.

        let res = data[0];
                // Run the insert of insert objects through a loop.
                this.returned_invoice_id = this.new_invoice_id.last_insert_id;
                console.log(this.returned_invoice_id);

// now inset the items
let  count_of_items = Object.keys(this.invoiceItemsList).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0; i < count_of_items; i++) {
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.addSubjectInvoiceItem(invoiceData, this.returned_invoice_id);
// :: now update subjectBillingItems Status using the model subjectbillingitemid.
let invoice_status = "INVOICED";
this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.returned_invoice_id, this.subject_number, invoiceData);
  } // end for

        this.toastr.success('Invoice Entered');
        this.closeParentModel.emit();
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
        this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
};



   addSubjectInvoiceItem(model, invoice_id){
    this._demoService.addSubjectInvoiceItem(model, invoice_id).subscribe(
      data => {  this.new_invoice_item_id = data; // this is the retuned json upon creation.
        // let res = data[0];
                        // Run the insert of insert objects through a loop.
                        this.returned_invoice_item_id = this.new_invoice_item_id.last_insert_id;
                        console.log(this.returned_invoice_id);
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   }


   addSubjectWorkOrderItem(model, work_order_id){
    this._demoService.addSubjectWorkOrderItem(model, work_order_id).subscribe(
      data => {  this.new_work_order_item_id = data; // this is the retuned json upon creation.
        // let res = data[0];
                        // Run the insert of insert objects through a loop.
                        this.returned_work_order_item_id = this.new_work_order_item_id.last_insert_id;
                      //  console.log(this.returned_work_order_item_id);
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   }


// :: FIX :: CURRENT SPOTTHis needs to be totally re-written and followed through from start to check what I am actually doing here
// :: !!! GOING WRONG API NEEDS TO UPDATE BY invoice_item_id // Not by billing_item_id???
   updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model){
    this._demoService.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   }



   updateSubjectCostItemWorkOrderStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number, agent_id, work_order_model){
    // tslint:disable-next-line:max-line-length
    this._demoService.updateSubjectCostItemWorkOrderStatusAgentID(work_order_status, subject_cost_item_id, work_order_id, work_order_number, agent_id, work_order_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   };



// can also run from a child component.

// :: Note This is throwoing errors. But still works (all calculations work regardless of console.errors)
setExpandedValue(value) {
  this.expanded2 = value;
};


// new working gst function august 2022
doCalculations() {


  // this.work_order_tax = this.work_orderItemsList.reduce((a, b) => a += (b.tax * b.qty), 0); // now calculates
 this.work_order_tax = this.workOrderItemsList.reduce((a, b) => a + Number(b.tax), 0); // now calculates
 this.work_order_model.work_order_gst = this.work_order_tax;

  // this.toastr.info('Calculating...');
  this.work_order_total = this.workOrderItemsList.reduce((a, b) => a += (b.cost_task_fee * b.qty), 0);
  this.work_order_model.work_order_total = this.work_order_total += this.work_order_tax;
 
  // :: Test Stop errors of input
 // this is needed but does throw errows 
  this.invoiceForm.controls['work_order_total'].setValue(this.work_order_total);

 


  this.work_order_subtotal = (this.work_order_model.work_order_total - this.work_order_tax);
  this.work_order_model.work_order_subtotal = this.work_order_subtotal;
  this.invoiceForm.controls['work_order_subtotal'].setValue(this.work_order_subtotal);

  // updated by
  let update_user = this.sessionUserId;
  this.work_order_model.updated_by = this.sessionUserId;  
  this.invoiceForm.controls['updated_by'].setValue(update_user);


  // this.work_order_tax = (this.work_order_model.work_order_total / (100 / 10));

  this.invoiceForm.controls['work_order_gst'].setValue(this.work_order_tax);


  this.work_order_model = this.workOrderItem;
  
 // alert('test');
}



// new working gst function august 2022
doCalculations_ONLOAD() {


  // this.work_order_tax = this.work_orderItemsList.reduce((a, b) => a += (b.tax * b.qty), 0); // now calculates
 this.work_order_tax = this.workOrderItemsList.reduce((a, b) => a + Number(b.tax), 0); // now calculates
 this.work_order_model.work_order_gst = this.work_order_tax;

  // this.toastr.info('Calculating...');
  this.work_order_total = this.workOrderItemsList.reduce((a, b) => a += (b.cost_task_fee * b.qty), 0);
  this.work_order_model.work_order_total = this.work_order_total += this.work_order_tax;
 
  // :: Test Stop errors of input
 // this is needed but does throw errows 

  this.work_order_subtotal = (this.work_order_model.work_order_total - this.work_order_tax);
  this.work_order_model.work_order_subtotal = this.work_order_subtotal;

  // updated by
  let update_user = this.sessionUserId;
  this.work_order_model.updated_by = this.sessionUserId;  

  // this.work_order_tax = (this.work_order_model.work_order_total / (100 / 10));

  this.work_order_model = this.workOrderItem;
  
 // alert('test');
}



doCalculations__() {



  this.work_order_tax = this.workOrderItemsList.reduce((a, b) => a + Number(b.tax), 0); // now calculates
  this.work_order_model.work_order_gst = this.work_order_tax;
  


  // this.toastr.info('Calculating...');
      this.work_order_total = this.workOrderItemsList.reduce((a, b) => a += (b.cost_task_fee * b.qty), 0);
      this.work_order_model.work_order_total = this.work_order_total + this.work_order_tax; 
  // this.work_order_model.work_order_total = this.work_order_total; // seemed to fix form erros?

  if(this.invoiceForm.controls['work_order_gst']){
    this.invoiceForm.controls['work_order_gst'].setValue(this.work_order_tax);
}

  this.work_order_subtotal = (this.work_order_model.work_order_total - this.work_order_tax); // changed
  this.work_order_model.work_order_subtotal = this.work_order_subtotal;
  // :: Test Stop errors of input
 // this is needed but does throw errows?
 


// Try This instead
// this.work_order_model.work_order_total = this.work_order_total;

  // this.work_order_tax = (this.work_order_model.work_order_total / (100 / 10));
// this.work_order_tax = this.work_orderItemsList.reduce((a, b) => a += (b.tax * b.qty), 0); // now calculates




  if (this.invoiceForm.controls['work_order_subtotal']) {
        this.invoiceForm.controls['work_order_subtotal'].setValue(this.work_order_subtotal);
  }

  if ( this.invoiceForm.controls['work_order_total']) {
    this.invoiceForm.controls['work_order_total'].setValue(this.work_order_total);   
    // this.invoiceForm.control.get('work_order_total').setValue(this.work_order_total); // remplate
};



  // updated by
  let update_user = this.sessionUserId;
  this.work_order_model.updated_by = this.sessionUserId;
  if (this.invoiceForm.controls['updated_by']) {
      this.invoiceForm.controls['updated_by'].setValue(update_user);
  }



  this.work_order_model = this.workOrderItem;
 // alert('test');
}



doCalculations_() {
  // this.toastr.info('Calculating...');
  this.work_order_total = this.workOrderItemsList.reduce((a, b) => a += (b.cost_task_fee * b.qty), 0);
  this.work_order_model.work_order_total = this.work_order_total; 
  // this.work_order_model.work_order_total = this.work_order_total; // seemed to fix form erros?

  // :: Test Stop errors of input
 // this is needed but does throw errows?
 
if ( this.invoiceForm.controls['work_order_total']) {
      this.invoiceForm.controls['work_order_total'].setValue(this.work_order_total);   
      // this.invoiceForm.control.get('work_order_total').setValue(this.work_order_total); // remplate
};

// Try This instead
// this.work_order_model.work_order_total = this.work_order_total;

  // this.work_order_tax = (this.work_order_model.work_order_total / (100 / 10));
// this.work_order_tax = this.work_orderItemsList.reduce((a, b) => a += (b.tax * b.qty), 0); // now calculates
this.work_order_tax = this.workOrderItemsList.reduce((a, b) => a + Number(b.tax), 0); // now calculates
this.work_order_model.work_order_gst = this.work_order_tax;
  if(this.invoiceForm.controls['work_order_gst']){
        this.invoiceForm.controls['work_order_gst'].setValue(this.work_order_tax);
  }

  this.work_order_subtotal = (this.work_order_total - this.work_order_tax); // changed
  this.work_order_model.work_order_subtotal = this.work_order_subtotal;
  if (this.invoiceForm.controls['work_order_subtotal']) {
        this.invoiceForm.controls['work_order_subtotal'].setValue(this.work_order_subtotal);
  }

  // updated by
  let update_user = this.sessionUserId;
  this.work_order_model.updated_by = this.sessionUserId;
  if (this.invoiceForm.controls['updated_by']) {
      this.invoiceForm.controls['updated_by'].setValue(update_user);
  }

  this.work_order_model = this.workOrderItem;
 // alert('test');
}






updateSubjectInvoice(invoice_model){
  this._demoService.updateSubjectInvoice(invoice_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });

// need to update the invoice items as well. or do we update them as we make changes to the invoice itself??? Start Here and work out.
// now inset the items
let  count_of_items = Object.keys(this.invoiceItemsList).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0; i < count_of_items; i++) {
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.updateSubjectInvoiceItem(invoiceData, this.invoice_id);
// :: TODO need to update subjectBillingItem, as status invoiced.
let invoice_status = "INVOICED";
this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.invoice_id, this.invoice_number, invoiceData);
  } // end for


  this.toastr.success('Invoice Updated');
  this.closeParentModel.emit();
  this.refreshSujectInvoicePage(this.subject_id);


     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }



 updateSubjectWorkOrder(work_order_model){
  this._demoService.updateSubjectWorkOrder(work_order_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });

// need to update the invoice items as well. or do we update them as we make changes to the invoice itself??? Start Here and work out.
// now inset the items
let  count_of_items = Object.keys(this.workOrderItemsList).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0; i < count_of_items; i++) {
   let workOrderData = this.workOrderItemsList[i];
   // :: add the items
   this.updateSubjectWorkOrderItem(workOrderData, this.work_order_id);
// :: TODO need to update subjectBillingItem, as status invoiced.
let work_order_status = "APPLIED";
// tslint:disable-next-line:max-line-length
this.updateSubjectCostItemWorkOrderStatus(work_order_status, workOrderData.subject_cost_item_id, this.work_order_id, this.work_order_number, this.selected_agent_id, workOrderData);
  } // end for

// Calls the refresh function on the subjectCostComponent
  // this._SubjectCostComponent.refreshSujectWorkOrderPage(this.subject_id);
  // this.toastr.success('Work Order Updated');
  // this.closeParentModel.emit();
  
  // Turn off Redirect.
  // this.refreshSujectWorkOrderPage(this.subject_id)

            // Calls the refresh function on the subjectCostComponent
            this.toastr.success('Work Order Updated, Please Refresh Page Below.');
            this.gfunc.insertLog_UpdateWorkOrder(work_order_model);
            // this._SubjectCostComponent.refreshSujectWorkOrderPage(this.subject_id);
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    },
    () => {
      this.closeParentModel.emit(); // closes this modal.
      this.refreshSujectWorkOrderPage(this.subject_id);
     }
);
 }



 updateSubjectInvoiceAndApprove(invoice_model){
  this._demoService.updateSubjectInvoice(invoice_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });

// need to update the invoice items as well. or do we update them as we make changes to the invoice itself??? Start Here and work out.
// now inset the items
let  count_of_items = Object.keys(this.invoiceItemsList).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0; i < count_of_items; i++) {
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.updateSubjectInvoiceItem(invoiceData, this.invoice_id);
// :: TODO need to update subjectBillingItem, as status invoiced.
let invoice_status = "INVOICED";
this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.invoice_id, this.invoice_number, invoiceData);
  } // end for

    // :: updates the invoice status.
  invoice_model.invoice_status_id = 3; // set to approve
  this.updateInvoiceStatus(invoice_model);

  this.toastr.success('Invoice Updated + Approved');
  this.closeParentModel.emit();
  // this.refreshSujectInvoicePage(this.subject_id);





     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }



 updateSubjectWorkOrderAndApprove(work_order_model){
  this._demoService.updateSubjectWorkOrder(work_order_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });

// need to update the invoice items as well. or do we update them as we make changes to the invoice itself??? Start Here and work out.
// now inset the items
let  count_of_items = Object.keys(this.workOrderItemsList).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0; i < count_of_items; i++) {
   let workOrderData = this.workOrderItemsList[i];
   // :: add the items
   this.updateSubjectWorkOrderItem(workOrderData, this.work_order_id);
// :: TODO need to update subjectBillingItem, as status work_orderd.


let work_order_status = "APPLIED";
// tslint:disable-next-line:max-line-length
this.updateSubjectCostItemWorkOrderStatus(work_order_status, workOrderData.subject_cost_item_id, this.work_order_id, this.work_order_number, this.selected_agent_id, workOrderData);
  } // end for

    // :: updates the work_order status.
  work_order_model.work_order_status_id = 3; // set to approve
  this.updateWorkOrderStatus(work_order_model);

  this.toastr.success('Work Order Updated + Approved');
  this.gfunc.insertLog_UpdateWorkOrder(work_order_model);
  this.closeParentModel.emit();
   this.refreshSujectWorkOrderPage(this.subject_id);
     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }



 updateSubjectInvoiceItem(model, invoice_id){
  this._demoService.updateSubjectInvoiceItem(model, invoice_id).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }





 updateSubjectWorkOrderItem(model, work_order_id){
  this._demoService.updateSubjectWorkOrderItem(model, work_order_id).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }



toggleShow(index) {
 // this.isShowEdit = ! this.isShowEdit;
// if (this.isShow === index){
// this.isShow = '';
// }else{
//   this.isShow = index; // sets to the array row.d
// }
this.isShow = index; // sets to the array row.d

  }

  toggleHide(index) {
 // this.isShowEdit = ! this.isShowEdit;
// if (this.isShow === index){
// this.isShow = '';
// }else{
//   this.isShow = index; // sets to the array row.d
// }
this.isShow = index; // sets to the array row.d

  }



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}



// :: Parent / Child modal test
closeParentModel2() {
 //  alert('parent component function.');
   this.modalRef.hide();
// now refresh the invoice items list from the new items.
    // empty your array first
    // this.invoiceItemsList.length = 0;
    this.workOrderItemsList.length = 0;
    this.getSubjectCostItems(this.subject_id);


 // this.closeParentModel.emit(); // ?shuts invoice window
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


// :: Parent / Child modal test
closeParentModel3() {
  //  alert('parent component function.');
    this.modalRef.hide();
 };

RemoveElementFromObjectArray(key: number) {
  let data = this.workOrderItemsList;
      // data.forEach((value, index) => {
      //   if ( value.subject_billing_item_id === key) {
      //     this.row_data.splice(index, 1); }
      // });
      data.forEach((value,index)=>{
        if(value.subject_cost_item_id==key) data.splice(index,1);
    });
// do I need to refesh like adding?
this.doCalculations();

     };


deleteSubjectInvoiceItem(model, invoice_item_id){
    if (confirm('Are you sure you want to delete this item from the invoice. It will still appearr in billing items, yet to be invoiced.')) {
      this._demoService.deleteSubjectInvoiceItem(model, invoice_item_id).subscribe(
         data => {
          // update the status of subjectbillingItems
          let invoice_status = 'NOT-INVOICED';
          let invoice_id = 0;
          let invoice_number = 0;
          
          let subject_billing_item_id = model.subject_billing_item_id;
          this.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, model);
          // refresh the list
         ////  this.getSubjectBillingItems(this.invoice_id); // seemed to remove all items from the list??? upon delete when they are still in the database...
          // refresh the bottom widow of sibjectBillingItems from Modal
          this.refreshSujectInvoicePage(this.subject_id);
          /// :: lets do a refresh of the invoice data to refresh the invoice_items_list.
          this.getInvoiceItmes(this.invoice_id);
           return true;
         },
         error => {
           console.error('Error deleting Job File!');
           console.error(error);
           // return Observable.throw(error);
         }
      );
  }
 
}

deleteSubjectWorkOrderItem(model, work_order_item_id){
  // if (confirm('Are you sure you want to delete this item from the work order. It will still appearr in cost items, yet to be applied.')) {
    this._demoService.deleteSubjectWorkOrderItem(model, work_order_item_id).subscribe(
       data => {
        // update the status of subjectbillingItems
        let work_order_status = 'NOT-APPLIED';
        let work_order_id = 0;
        let work_order_number = 0;
        // let agent_id = null;
        let agent_id = 0;

        
        let subject_cost_item_id = model.subject_cost_item_id;
        this.updateSubjectCostItemWorkOrderStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number, agent_id, model);
        // refresh the list
       ////  this.getSubjectBillingItems(this.invoice_id); // seemed to remove all items from the list??? upon delete when they are still in the database...
        // refresh the bottom widow of sibjectBillingItems from Modal
        // this.refreshSujectWorkOrderPage(this.subject_id);
        // this.gfunc.globalJobSubjectCostViewSkipRoute(this.subject_id);
        /// :: lets do a refresh of the invoice data to refresh the invoice_items_list.

        this.getWorkOrderItems(this.work_order_id);
        //  return true;
       },
       error => {
         console.error('Error deleting!');
         console.error(error);
         // return Observable.throw(error);
       }
    );
// }

}




deleteSubjectWorkOrderItemAndCostItems(model, work_order_item_id){
  // if (confirm('Are you sure you want to delete this item from the work order. It will still appearr in cost items, yet to be applied.')) {
    this._demoService.deleteSubjectWorkOrderItem(model, work_order_item_id).subscribe(
       data => {
        // update the status of subjectbillingItems
        let work_order_status = 'NOT-APPLIED';
        let work_order_id = 0;
        let work_order_number = 0;
        // let agent_id = null;
        let agent_id = 0;
        
        let subject_cost_item_id = model.subject_cost_item_id;
        // this.updateSubjectCostItemWorkOrderStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number, agent_id, model);
        this.deleteSubjectCostItem(subject_cost_item_id); // seemed to remove all items from the list??? upon delete when they are still in the database...
        // refresh the bottom widow of sibjectBillingItems from Modal
        // this.refreshSujectWorkOrderPage(this.subject_id);
        // this.gfunc.globalJobSubjectCostViewSkipRoute(this.subject_id);
        /// :: lets do a refresh of the invoice data to refresh the invoice_items_list.

        this.getWorkOrderItems(this.work_order_id);
        //  return true;
       },
       error => {
         console.error('Error deleting!');
         console.error(error);
         // return Observable.throw(error);
       }
    );
// }

}



// Loads from add new billing items modal.
// refreshInvoiceItemsBelow() {
//   console.log('Reloading Items');
//   this.getInvoice(this.invoice_id);
//   this.getInvoiceItmes(this.invoice_id);
// }

refreshWorkOrderItemsBelow() {
  console.log('Reloading Items');
  this.getWorkOrder(this.work_order_id);
  this.getWorkOrderItems(this.work_order_id);
}


 refreshSujectInvoicePage(subject_id){
      this.router.navigateByUrl('admin', {skipLocationChange: true}).then(() =>
                    this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));
    
    }

    refreshSujectWorkOrderPage(subject_id){
      // this.router.navigateByUrl('admin', {skipLocationChange: true}).then(() =>
      //               this.router.navigate(['/admin/jobs/subject/cost/' + subject_id + '']));
                    this.gfunc.globalJobSubjectCostViewSkipRoute(subject_id);
    
    }


    updateInvoiceCommunicationStatus(invoice_model){
      invoice_model.invoice_id = this.invoice_id;
      this._demoService.updateInvoiceCommunicationStatus(invoice_model).subscribe(
        data => { // this.trace_candidate_update = data;
          // refresh the invoice:
   
        },
        error => {
         // console.error('Error saving Event!');
          this.toastr.error('Error Changing Status of Subject');
          return console.error(error);
        }
       // err => console.error(err),
       //
      )};
    
    updateInvoicePaymentStatus(invoice_model){
      invoice_model.invoice_id = this.invoice_id;
      this._demoService.updateInvoicePaymentStatus(invoice_model).subscribe(
        data => { // this.trace_candidate_update = data;
          // refresh the invoice:
  
        },
        error => {
         // console.error('Error saving Event!');
          this.toastr.error('Error Changing Status of Subject');
          return console.error(error);
        }
       // err => console.error(err),
       //
      )};
    
    
    updateInvoiceStatus(invoice_model){
     invoice_model.invoice_id = this.invoice_id;
     this._demoService.updateInvoiceStatus(invoice_model).subscribe(
       data => { // this.trace_candidate_update = data;
         // refresh the invoice:

       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error Changing Status of Subject');
         return console.error(error);
       }
      // err => console.error(err),
      //
     )};

         
    updateWorkOrderStatus(work_order_model){
      work_order_model.work_order_id = this.work_order_id;
      this._demoService.updateWorkOrderStatus(work_order_model).subscribe(
        data => { // this.trace_candidate_update = data;
          // refresh the invoice:
 
        },
        error => {
         // console.error('Error saving Event!');
          this.toastr.error('Error Changing Status of Subject');
          return console.error(error);
        }
       // err => console.error(err),
       //
      )};


      getSubjectAgentBrandsAssigned(subject_id) {
        this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
          (data) => {
            this.assignedBrandList = data;

          //  this.allEmailRecipients = data;
          },
          (err) => console.error(err),
          // () => console.log('Loaded Assigned Agents Loaded.')
        );
      }


      getSubjectCostItems(subject_id) {
        // empty array of invoiceItemsList first
       // this.invoiceItemsList = [];
        this.workOrderItemsList = [];
        this._demoService.getSubjectCostItems(subject_id).subscribe(
          data => { this.subject_cost_items = data;

          let newArr = Object(data).filter((sbi)=>(sbi.work_order_status === 'NOT-APPLIED'));

          let  count_of_items = Object.keys(newArr).length;
         //  let res = data[0];
           // Run the job data queries.

           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
            let res = newArr[i];
      // do some totals and tax calculations.

     let tax_percent;
     let tax_value = 0;
      if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4 ) {
        tax_percent = 10;
        tax_value = (res.cost_task_fee / (100 / tax_percent));
      }
      if(res.myob_tax_code_id == 2 || res.myob_tax_code_id == 5 ) {
        tax_percent = 0;
        tax_value = 0;
      }

            // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
           this.workOrderItemsList.push({
    work_order_number: res.job_number,
    cost_task_id: res.cost_task_id,
    subject_cost_item_id: res.subject_cost_item_id,
    cost_task_name: res.cost_task_name,
    myob_tax_code_id: res.myob_tax_code_id,
    myob_account_code_id: res.myob_account_code_id,
    cost_task_fee: res.cost_task_fee,
    cost_task_description: res.cost_task_description,
    subject_id: res.subject_id,
    subject_number: res.subject_number,
    job_id: res.job_id,
    job_number: res.job_number,
    qty: 1,
    unit_price: res.cost_task_fee,
    tax: tax_value,
    total: res.cost_task_fee,
    agent_id: this.agent_id, // agent ID ionce selected in model.
    agent_full_name: this.agent_full_name // agent ID ionce selected in model.
          });
    
    
          this.workOrderItemsList = this.workOrderItemsList;
    
    // this.invoiceItemsList = [{
    //   invoice_number: res.job_number,
    //   billing_task_id: res.billing_task_id,
    //   subject_billing_item_id: res.subject_billing_item_id,
    //   billing_task_name: res.billing_task_name,
    //   myob_tax_code_id: res.myob_tax_code_id,
    //   myob_account_code_id: res.myob_account_code_id,
    //   billing_task_fee: res.billing_task_fee,
    //   billing_task_description: res.billing_task_description,
    //   subject_id: res.subject_id,
    //   subject_number: res.subject_number,
    //   job_id: res.job_id,
    //   job_number: res.job_number,
    //   qty: 1,
    //   unit_price: res.billing_task_fee,
    //   tax: tax_value,
    //   total: res.billing_task_fee,
    //         }];
    
        } // end for loop count
    
      // do some global calculations
    // get sum of msgCount prop across all objects in array
    // gets fee * qty adds them all up
    // this.invoice_total = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);
    this.doCalculations();
    
         },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }
    





      deleteWorkOrderAndSetCostItems(work_order_model){
        if (confirm('Are you sure you want to delete this Supplier Invoice in Both Myob + SOP. All items will be placed back into Supplier cost items, yet to be invoiced.')) {
       
       
       
       if (work_order_model.myob_id){
         this._WorkOrdersGridComponent.deleteMyobServiceWorkOrderModel(work_order_model);
       };
      
       
          // get all items and loop  
        // remove function and update subject billing items "not-invoiced"
        // end loop
      console.log( 'WorkOrderID: ' + work_order_model.work_order_id);
        // this.getInvoiceItmes(invoice_model.invoice_id);
        this._demoService.getSubjectWorkOrderItems(work_order_model.work_order_id)
        .pipe(
          retry(10), // you retry 3 times
          delay(1200) // each retry will start after 1 second,
       )
        .pipe(
          this.toastr.observe({
             loading: 'Connecting...Pushing data...Updating',
             success: '🚀',
             error: '😡'
          })
        )
        .subscribe(
          (data) => {
            this.workOrderItemsList = data;
            let res = data[0];
           // this.invoice_item_model = this.invoiceItemsList;
           console.log( JSON.stringify(this.workOrderItemsList) );
            let newArr = data;
                let  count_of_items = Object.keys(newArr).length;
                for(let i=0;i < count_of_items; i++) {
                        let res = newArr[i];
                        // console.log('Item:' + i + ' ID: ' + res.invoice_item_id);
                        this.deleteSubjectWorkOrderItem(res, res.work_order_item_id);
                        // this updates the status NOT invoice of all subject invoice itmes;
                }// end for loop
        // then remove invoice_items and invoice data rows
              this.deleteWorkOrderAndItems(work_order_model);
              /// do I need to allocate the items back????????
              this.toastr.success('Supplier Invoice Removed and Subject Cost Items used now set "Not Invoiced".');
              // Now Reload the page.
              this.gfunc.insertLog_DeleteWorkOrder(work_order_model);
              this.refreshSujectWorkOrderPage(this.subject_id);

              // close the invoice window
              //  this.modalRef.hide();
              this.closeParentModel.emit()
          },
          (err) => console.error(err),
         // () => console.log('Brand Loaded.')
          ); // end subscribe.
      } // end confirm
      }
      
      
      deleteWorkOrderAndItems(model) {
        // if (confirm('Are you sure you want to delete this invoice and items? ')) {
          this._demoService.deleteWorkOrder(model.work_order_id).subscribe(
             data => {
             //  this.getTraceCandidateNotes(this.trace_candidate_id);
               return true;
             },
             error => {
               console.error('Error deleting Supplier Invoice!');
              return console.log(error);
             }
          );
      // }
      }


    
      deleteSubjectCostItem(subject_cost_item_id) {
        this._demoService.deleteSubjectCostItem(subject_cost_item_id).subscribe(
          data => { // this.subject_billing_items = data;
          // let res = data[0];
           // Run the job data queries.
         this.toastr.success('Subject Cost Item Removed.');
        // this.refreshGrid();
          },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }




      


  }

// Allows formatting of dates etc...
export class DatePipeComponent {
  today: number = Date.now();
  fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
// tslint:disable-next-line:eofline
}